import { useState } from "react"
import { Button } from "../../../components/Buttons"
import Modal from "../../../components/Modal"
import OTPSection from "./OTPSection"
import logo from "../../../assets/logo.png"
import googleIcon from "../../../assets/Icons/googleIcon.svg"
import LoginPhoneNumberSection from "./LoginPhoneNumberSection"
import PasswordSection from "./PasswordSection"
import { useNavigate } from "react-router-dom"
import { CloseIcon } from "../../../assets/Icons/commonIcon"
import {
  emailValidations,
  isEmailValid,
  isMobileNumberValid,
} from "../../../Utils/Validations"
import { useDispatch } from "react-redux"
import { setUserData } from "../../../redux/userSlice"

const RenderButton = ({ showLoginMode, setShowLoginMode }) => {
  return (
    <div className="w-[125%]">
      {showLoginMode === "otp" || showLoginMode === "password" ? (
        <Button
          variant="secondary"
          className="w-[100%] flex justify-center font-Apparat font-[600] !text-[13px] !text-[#59606E]"
          title={`Login with ${showLoginMode === "otp" ? "Password" : "OTP"}`}
          onClick={() => setShowLoginMode("email")}
        />
      ) : (
        <Button
          variant="secondary"
          className="w-[100%]"
          onClick={() => setShowLoginMode("google")}
        >
          <span className="flex justify-center items-center gap-2">
            <img src={googleIcon} />
            <span className="mt-[4px] font-Apparat font-[600] text-[13px] text-[#59606E]">
              Continue with Google
            </span>
          </span>
        </Button>
      )}
    </div>
  )
}

// showLoginMode is a state variable that is used to toggle between the login modes ["email", "otp", "password", "google"]
// formStates is a state variable that is used to store the form data
// handleChange is a function that is used to update the formStates state variable

const LoginSection = ({ isOpen, toggleSignUpLoginModal, onPressClose }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [showLoginMode, setShowLoginMode] = useState("email")
  const [formStates, setFormStates] = useState({
    phoneNumber: "",
    isCheckboxChecked: false,
    password: "",
    otp: "",
  })

  const handleChange = (e) => {
    console.log(e)
    const { name, value } = e.target
    console.log(e, name, value)
    setFormStates({ ...formStates, [name]: value })
  }

  // handle the form rendering based on the showLoginMode state variable
  const handleSubmit = () => {
    if (showLoginMode === "email" && !isNaN(formStates?.email)) {
      setShowLoginMode("otp")
    } else if (showLoginMode === "email" && isNaN(formStates?.email)) {
      setShowLoginMode("password")
    } else if (showLoginMode === "otp" || showLoginMode === "password") {
      dispatch(setUserData({ openLoginModal:false, isAuthenticated: true }))
      navigate("/dashboard")
    } else {
      setShowLoginMode("password")
    }
  }

  // enable or disable the button based on the form data
  const isValidate = () => {
    if (
      !formStates?.email?.length &&
      !formStates?.password?.length &&
      !formStates?.otp?.length === 0
    ) {
      return false
    }
    if (showLoginMode === "email" && !isNaN(formStates?.email)) {
      return isMobileNumberValid(formStates?.email)
    } else if (showLoginMode === "email" && isNaN(formStates?.email)) {
      return isEmailValid(formStates?.email)
    } else if (showLoginMode === "otp" || showLoginMode === "password") {
      return formStates[showLoginMode].length >= 4
    } else {
      return false
    }
  }

  const sendOTP = () => {
    alert("OTP Sent")
  }
  return (
    <Modal visible={isOpen}>
      <div className="w-[1080px] h-[720px] bg-gradient-to-b from-[#FFFFFF] from-0%  to-[#FFFFFF] to-50% rounded-[24px] overflow-hidden  p-[38px] flex flex-col justify-between ">
        <div className="flex justify-end w-[100%]">
          <a onClick={() => onPressClose()} className="cursor-pointer">
            <CloseIcon />
          </a>
        </div>

        <div className="flex flex-1 justify-center items-center">
          <div className="flex flex-col">
            <div>
              <img
                src={logo}
                alt="FastFin Logo"
                className="h-[34.4px] w-[121.35px]"
              />
            </div>

            <div className="flexCol justify-center items-start  w-[80%]">
              {showLoginMode === "email" ? (
                <LoginPhoneNumberSection
                  value={formStates?.email}
                  onChange={(text) => handleChange(text)}
                  visible={showLoginMode === "email"}
                  onClick={() => {}}
                />
              ) : null}
              <div className="mt-[100px]">
                <OTPSection
                  onChange={(data) =>
                    setFormStates({ ...formStates, otp: data })
                  }
                  phoneNumber={formStates?.email}
                  otp={formStates?.otp}
                  sendOTP={sendOTP}
                  onClick={() => sendOTP()}
                  onClickEdit={() => setShowLoginMode("email")}
                  visible={showLoginMode === "otp"}
                />
              </div>

              <PasswordSection
                onChange={handleChange}
                value={formStates?.password}
                onClick={() => alert("hi")}
                visible={showLoginMode === "password"}
              />

              <Button
                variant="primary"
                title="Continue"
                className=" text-primary font-[700] mt-[12px] !text-[16px] leading-[24px]"
                disabled={!isValidate()}
                onClick={() => {
                  handleSubmit()
                }}
              />

              <div className="flex w-[130%] items-center gap-2 my-[20px]">
                <div className="border border-1 w-[45%] h-[1px]" /> or{" "}
                <div className="border border-1 w-[45%] h-[1px]" />
              </div>
              <RenderButton
                showLoginMode={showLoginMode}
                setShowLoginMode={setShowLoginMode}
              />
            </div>
          </div>
        </div>

        {showLoginMode === "email" ? (
          <p className="text-center mt-[50px] font-[400] text-[14px] text-[#424952D9]">
            New to Fastfin?{" "}
            <span
              className="font-Apparat font-[400] text-[14px] underline text-[#04B085] cursor-pointer"
              onClick={() => toggleSignUpLoginModal()}
            >
              Sign up
            </span>
          </p>
        ) : null}
      </div>
    </Modal>
  )
}

export default LoginSection
